export default __webpack_public_path__ + "static/media/news.875003c6.jpg";